import React from 'react'


export default function RightNavigation () {
  return (
    <div>
      Right Navigation
    </div>
  )
}

